import React from 'react';
import AboutUsLayer from '../../Layers/About_usLayer.jsx';
import Clients from '../../Clients/Clients.jsx';
import ServiceCradPage from './ServiceCradPage.jsx';
import ScrollToTop from '../../../ScrollToTop.js';

const ServicePage = () => {
    return <>
          <ScrollToTop />

        <AboutUsLayer/>

        <ServiceCradPage/>
        <Clients/>
        </>
}

export default ServicePage;
